export function loadImage(src: string) {
    const img = new Image();
    img.src = src;
    return new Promise<HTMLImageElement>((resolve, reject) => {
        img.onload = function () {
            resolve(img);
        };
        img.onerror = function (err) {
            reject(err);
        };
    });
}
